import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { agencyEndpointIds } from 'root/src/shared/agency/agency.constants'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { AGENCY_ACCOUNT_MANAGERS_LIST_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default ({ email }) => async (dispatch, getState) => {
	const state = getState()

	const { error } = await invokeApiRequest(
		agencyEndpointIds.INVITE_AGENCY_ACCOUNT_MANAGER, { email }, state,
	)

	if (error) {
		throw error
	}

	return pushRouteClient({
		routeId: AGENCY_ACCOUNT_MANAGERS_LIST_ROUTE_ID,
	})
}
